import { AiOutlineEdit } from "react-icons/ai";
import Radio from "../../../../../global/Radio/Radio";
import user from "../../../../../assets/images/user.png";

const CustomerElements = ({ item, Customer, handleEdit, setCustomer }: any) => {
  return (
    <div
      onClick={() => setCustomer(item)}
      className={`border p-2 py-4 flex-between-start rounded-2xl transition duration-500 cursor-pointer
     ${Customer?.id === item.id ? "border-2 border-tomato" : ""}
    `}
    >
      <div className="flex-start-center">
        <Radio
          values={Customer?.id}
          checked={item.id}
          wrapperClassName="pr-2"
        />
        <img width={40} src={user} alt="customer" className="" />
        <div className="pr-3">
          <p className="text-dark text-base mb-1"> {item.name}</p>
          <p className="h-4">
            {item.telephones.length > 0 &&
              item.telephones.at(-1).telephonePrefix +
                item.telephones.at(-1).telNumber}
          </p>
        </div>
      </div>
      <span className="cursor-pointer" onClick={handleEdit}>
        <AiOutlineEdit size={20} className="text-darkBorder" />
      </span>
    </div>
  );
};

export default CustomerElements;
